@for (name of visibleNames(); track name; let last = $last) {
    {{ name }}{{ !last ? ', ' : '' }}
}

@if (hiddenCount() > 0) {
    <span class="badge text-bg-secondary">+ {{ hiddenCount() }}</span>
}
